"use client"

import React, { useEffect } from "react"
import Confetti from "react-confetti"

interface Props {
  maxXDistance: number
  maxYDistance: number
}

export const ConfettiExplosion: React.FC<Props> = ({ maxXDistance, maxYDistance }) => {
  const [isExploding, setIsExploding] = React.useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsExploding(true)
    }, 200)
  }, [])

  return (
    <>
      {isExploding && (
        <Confetti
          recycle={false}
          numberOfPieces={1000}
          height={maxYDistance}
          width={maxXDistance}
          colors={["#F0E5FE", "#DABDFF", "#B47BFF", "#9C52FD", "#4E00B2"]}
        />
      )}
    </>
  )
}
